import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import ActionButton from '../shared/buttons/ActionButton';
import permissionsProvider from '../../utilities/permissionsProvider';

const FranchiseItem = ({
    item,
    editItem,
    enableItem,
    disableItem
}) => {

    const restrictDelete = !permissionsProvider.canDelete(item.acl);

    return (
        <tr className={item.isEnabled ? '' : 'disabled-item'}>
            <CustomTd content={item.name} />
            <CustomTd content={item.number} />
            <CustomTd content={item.isEnabled ? "Active" : "Disabled"} />
            <CustomTd className="two-button-cell">
                    <ActionButton
                        buttonText="Edit"
                        imgSource="/images/edit.svg"
                        onClick={editItem}
                    />
                {item.isEnabled ?
                        (
                            <ActionButton
                                buttonText="Disable"
                                imgSource="/images/x.svg"
                                onClick={disableItem}
                                disabled={restrictDelete}
                            />
                        ) : (
                            <ActionButton
                                buttonText="Enable"
                                imgSource="/images/check.svg"
                                onClick={enableItem}
                                disabled={restrictDelete}
                            />
                        )}
            </CustomTd>
        </tr>
    );
}

export default FranchiseItem;